export default __webpack_public_path__ + "static/media/StuonB1.fabb9ace.png";